import React from "react";

const MAP = {
  verified: "bg-[#EBF6F0] text-[#1E6B47]",
  pending: "bg-[#FFF6E9] text-[#8A6212]",
  rejected: "bg-[#FBEAEA] text-[#9B2C2C]",
  suspended: "bg-[#F1F1F4] text-[#4A4A55]",
  draft: "bg-[#F1F1F4] text-[#4A4A55]",
  published: "bg-[#EBF6F0] text-[#1E6B47]",
  closed: "bg-[#F1F1F4] text-[#4A4A55]",
  confirmed: "bg-[#EBF6F0] text-[#1E6B47]",
  declined: "bg-[#FBEAEA] text-[#9B2C2C]",
  approved: "bg-[#EBF6F0] text-[#1E6B47]",
  restricted: "bg-[#FBEAEA] text-[#9B2C2C]",
};

export function StatusBadge({ status, label, testId }) {
  return (
    <span
      data-testid={testId || `status-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-semibold ${MAP[status] || "bg-secondary text-secondary-foreground"}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
